// utils
import { cn } from '@utils/cn';

// UI
import NavBar from '@ui/components/NavBar';
import Logos from '@app/marketing/components/Logos';
import Testimonials from '@app/marketing/components/Testimonials';
import Headline from '@ui/components/Headline';
import Subtitle from '@ui/components/Subtitle';
import Footer from '@ui/components/Footer';

// Types
import { TestimonialData } from '@app/marketing/types';
import { NavStep } from '@ui/components/NavBar/types';
import type { FC, ReactNode } from 'react';

export interface Props {
    children: any;
    title: ReactNode;
    description: ReactNode;
    logoUrls?: string[];
    testimonials?: TestimonialData[];
    activeStep: NavStep;
    className?: string;
}

const MainLayout: FC<Props> = ({
    children,
    logoUrls,
    testimonials,
    title,
    description,
    activeStep,
    className,
}) => {
    return (
        <>
            <NavBar activeStep={activeStep} />

            <div className={cn('mx-auto mt-12 max-w-screen-lg px-4 pb-24 md:mt-16', className)}>
                <div className="mb-12 text-center">
                    <Headline>{title}</Headline>
                    <Subtitle>{description}</Subtitle>
                </div>

                {children}

                {logoUrls && <Logos logos={logoUrls} />}
                {testimonials && <Testimonials testimonials={testimonials} />}

                <Footer />
            </div>
        </>
    );
};

export default MainLayout;
